// extracted by mini-css-extract-plugin
module.exports = {"root":"video-player_root__4FJA9"};